import { connect } from 'react-redux';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import classnames from 'classnames';
import mobile from 'is-mobile';
import { APP_PATH } from '../../const';
import DeleteNotification from './DeleteNotification';

const links = [
  { route: '', caption: 'My resources' },
  { route: 'saved', caption: 'Saved resources' },
];

const RouteTabLink = ({ caption, route, icon, isActive }) =>
  <Link icon={icon} to={`${APP_PATH}/${route}`} className={classnames('tds-btn tds-btn--lg js-tab tds-tabs__trigger tds-btn--tertiary', { active: isActive })}>
    {caption}
  </Link>;

RouteTabLink.propTypes = {
  caption: PropTypes.string,
  route: PropTypes.string,
  icon: PropTypes.string,
  isActive: PropTypes.bool,
};

@connect((state) => ({
  notifications: state.profileModule.notifications,
  isAuthenticated: state.profileModule.isAuthenticated,
}))
export default class HeaderNav extends Component {
  render() {
    const { notifications } = this.props;
    return <div className="user-dashboard-header-nav">
      <div className="pt-2 px-2">
        <div className={mobile() ? 'js-tab tds-tabs' : 'js-tab tds-tabs tds-tabs--left-aligned'}>
          {notifications.map((notification) => (
            <div key={`not${notification.notificationId}`} className={classnames([`not-${notification.notificationId}`])}>
              <DeleteNotification {...notification} />
            </div>
          ))}
          <div className="tds-tabs__triggers">
            {links.map(link => <RouteTabLink caption={link.caption} route={link.route} isActive={link.route === this.props.route} key={link.route} />)}
          </div>
        </div>
      </div>
    </div>;
  }
}

HeaderNav.propTypes = {
  notifications: PropTypes.object,
  route: PropTypes.string,
};
